import React from 'react'
import styled from 'styled-components';
import BookMemoResponse from './BookMemoResponse'
import {Button} from 'react-bootstrap'
import {BooksitoutServer} from '../../../../config/BooksitoutServer';
import toast from 'react-hot-toast';
import ColorConfig from "../../../../config/ColorConfig";
import Modal from '../../../../common/Modal';
import parse from 'html-react-parser';
import useBookDetailStore from "../useBookDetailStore";

interface Props {
    isOpen: boolean
    close: () => void
    memo: BookMemoResponse
    openEditModal: (memo: BookMemoResponse) => void
}

const BookDetailMemoDetailModal: React.FC<Props> = ({isOpen, close, memo, openEditModal}) => {
    const {deleteMemo} = useBookDetailStore()

    const handleDelete = () => {
        if (!window.confirm('정말로 메모를 삭제할까요?')) return

        BooksitoutServer
            .delete(`/v1/book/memo/${memo.id}`)
            .then(() => {
                toast.success('메모를 삭제했어요.')
                deleteMemo(memo.id)
                close()
            })
            .catch(() => toast.error('오류가 났어요. 잠시 후 다시 시도해 주세요.'))
    }

    return (
        <Modal
            titleText={'✏️ 메모 자세히 보기'}
            isShowing={isOpen}
            onClose={close}
            size={'lg'}
            body={
                <>
                    <PageNumber>{memo.page}</PageNumber>
                    <Content>{parse(memo.content.replaceAll("\n", "<br/>"))}</Content>

                    <ButtonContainer>
                        <StyledButton variant={'book'} onClick={() => openEditModal(memo)}>수정</StyledButton>
                        <StyledButton variant={'book-danger'} onClick={handleDelete}>삭제</StyledButton>
                    </ButtonContainer>
                </>
            }
        />
    )
}

const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 10px;
`

const StyledButton = styled(Button)`
    height: 44px;
    padding: 0 24px;
    font-size: 15px;
`

const PageNumber = styled.div`
    font-size: 1.2rem;
    font-weight: bold;
    margin-bottom: 10px;
    color: ${ColorConfig.Primary};
`;

const Content = styled.p`
    font-size: 1rem;
    min-height: 200px;

    p {
        margin: 3px 0;
    }

    blockquote {
        background: #f1f1ef;
        border-radius: 4px;
        border: none;
        margin: 4px 0;
        padding: 10px 14px;
        color: #3b3b3b;
    }

    ul {
        list-style: disc;
        margin: 5px 0;
        padding-left: 40px;
    }

    ul li {
        margin: 0;
        padding: 2px 0;

        p {
            margin: 0;
        }
    }

    p:empty {
        display: none;
    }
`;

export default BookDetailMemoDetailModal